var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAccount(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 20,
    viewBox: "0 0 18 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2289_7269)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.625 0H1.875C0.841667 0 0 0.841667 0 1.875V18.125C0 19.1583 0.841667 20 1.875 20H15.625C16.6583 20 17.5 19.1583 17.5 18.125V1.875C17.5 0.841667 16.6583 0 15.625 0ZM16.25 18.125C16.25 18.4708 15.9708 18.75 15.625 18.75H1.875C1.52917 18.75 1.25 18.4708 1.25 18.125V1.875C1.25 1.52917 1.52917 1.25 1.875 1.25H15.625C15.9708 1.25 16.25 1.52917 16.25 1.875V18.125Z",
    fill: "#194142"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.74995 11.6208C10.9833 11.6208 12.8 9.80415 12.8 7.57081C12.8 5.33748 10.9833 3.52081 8.74995 3.52081C6.51662 3.52081 4.69995 5.33748 4.69995 7.57081C4.69995 9.80415 6.51662 11.6208 8.74995 11.6208ZM8.74995 4.77081C10.2958 4.77081 11.55 6.02498 11.55 7.57081C11.55 9.11665 10.2958 10.3708 8.74995 10.3708C7.20412 10.3708 5.94995 9.11665 5.94995 7.57081C5.94995 6.02498 7.20412 4.77081 8.74995 4.77081Z",
    fill: "#194142"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.49585 12.6417C4.24585 13.3 3.23335 14.3125 2.57502 15.5625C2.41252 15.8667 2.53335 16.2459 2.83752 16.4084C3.14169 16.5709 3.52085 16.45 3.68335 16.1459C4.22502 15.1167 5.05419 14.2875 6.08335 13.7459C8.87919 12.2709 12.3542 13.3459 13.8292 16.1459C13.9417 16.3584 14.1584 16.4792 14.3834 16.4792C14.4834 16.4792 14.5834 16.4542 14.675 16.4084C14.9792 16.2459 15.0959 15.8709 14.9375 15.5625C13.1417 12.1542 8.90835 10.8459 5.50419 12.6417H5.49585Z",
    fill: "#194142"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2289_7269"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 17.5,
    height: 20,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAccount);
export default __webpack_public_path__ + "static/media/account.6ae40833f69986027c997f0967426066.svg";
export { ForwardRef as ReactComponent };